<template>
  <div class="common-test-box-step">
    <div class="form-item-title">
      {{ formLabel }}
      <span class="required-mark" v-if="required">*</span>
    </div>
    <div class="input-area">
      <vs-input
        v-model="inputValue"
        color="#2D9CDB"
        class="full-width-input"
        :danger="!isValid"
        :danger-text="invalidMessage"
      />
      <div v-if="deleteButton" class="icon-button" @click="onClickDelete">
        <feather-icon
          icon="Trash2Icon"
          class="trash-icon-button"
          svg-classes="h-6 w-6"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M.CommonTextBoxStep",
  props: {
    isValid: {
      type: Boolean,
      default: true,
    },
    invalidMessage: {
      type: String,
      default: "",
    },
    formLabel: {
      type: String,
      required: true,
    },
    deleteButton: {
      type: Boolean,
      default: false,
    },
    onClickDelete: {
      type: Function,
      default: () => {},
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      //required: true,
    },
  },

  data() {
    return {
      inputValue: null,
    };
  },
  created() {
    this.inputValue = this.value;
  },
  watch: {
    value(value) {
      this.inputValue = value;
    },
    inputValue(value) {
      this.$emit("update:value", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";

.common-test-box-step {
  width: 100%;
  .form-item-title {
    margin-bottom: 6px;
  }
  .input-area {
    display: flex;
    .full-width-input {
      width: 100%;
    }
  }
  .required-mark {
    color: red;
  }
  .icon-button {
    cursor: pointer;
    justify-content: center;
    display: flex;
    align-items: center;
    margin-left: 10px;
    width: 36px;
    height: 36px;
  }
}
</style>
